module.exports = __webpack_public_path__ + "img/zhou6.6a943aba.png";